module.exports = __webpack_public_path__ + "static/media/unevenshoulder_severe_left.510545dc.png";